import { render, staticRenderFns } from "./SysPara.vue?vue&type=template&id=2d3d3fa5&"
import script from "./SysPara.vue?vue&type=script&lang=js&"
export * from "./SysPara.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports